export default [
  {
    value: 1,
    text: "Səyahət",
  },
  {
    value: 2,
    text: "Təhsil",
  },
  {
    value: 3,
    text: "Sport",
  },
  {
    value: 4,
    text: "Ektrim",
  }
]